import { render, staticRenderFns } from "./AccountActivate.vue?vue&type=template&id=04dc5f42"
import script from "./AccountActivate.vue?vue&type=script&lang=js"
export * from "./AccountActivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports